import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import {MatRipple} from '@angular/material/core';

@Component({
  selector: 'app-nav-card',
  imports: [MatRipple],
  templateUrl: './nav-card.component.html',
  styleUrl: './nav-card.component.scss',
})
export class NavCardComponent {

  public readonly lg: InputSignal<boolean> = input<boolean>(false);

  public readonly active: InputSignal<boolean> = input<boolean>(false);

  public readonly icon: InputSignal<string> = input<string>('');

  public readonly title: InputSignal<string> = input<string>('');

  public readonly selected: OutputEmitterRef<void> = output<void>();

  handleSelect(): void {
    this.selected.emit();
  }

  getBgImageStyle(): string {
    const icon = this.icon();
    return icon ? `background-image: url(/assets/icons/${icon})` : '';
  }

}
